export default "__VITE_ASSET__BlS$b5sp__"